// SPDX-FileCopyrightText: 2023 Kevin Nguyen <kevin@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from "@apollo/client";
export var GET_AREAS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query sequent_backend_area($electionEventId: uuid!) {\n        sequent_backend_area(where: {election_event_id: {_eq: $electionEventId}}, limit: 1000) {\n            id\n            name\n        }\n    }\n"], ["\n    query sequent_backend_area($electionEventId: uuid!) {\n        sequent_backend_area(where: {election_event_id: {_eq: $electionEventId}}, limit: 1000) {\n            id\n            name\n        }\n    }\n"])));
var templateObject_1;
